import { Controller, useForm } from 'react-hook-form';
import { NJButton, NJFormItem } from '@engie-group/fluid-design-system-react';
import { useDraftGuard } from './DirtyContext';

export function NameField({ label, value, save }: { label: string; value: string; save: (value: string) => void }) {
  const { control, handleSubmit, reset, formState: { isDirty } } = useForm({ defaultValues: { name: value } });
  useDraftGuard(isDirty);
  return <form className="sp-stack" onSubmit={handleSubmit(values => {
    const name = values.name.trim(); save(name); reset({ name });
  })}>
    <Controller name="name" control={control} rules={{ validate: name => !!name.trim() || 'Le nom est obligatoire.' }}
      render={({ field, fieldState }) => <NJFormItem id={`name-${label}`} label={label} value={field.value}
        onBlur={field.onBlur} onChange={event => {
          if (event.target instanceof HTMLInputElement) field.onChange(event.target.value);
        }} hasError={!!fieldState.error} subscriptMessage={fieldState.error?.message} />} />
    {isDirty && <NJButton label={`Enregistrer · ${label}`} type="submit" scale="sm" emphasis="subtle" />}
  </form>;
}
